var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aron-table',{key:_vm.route,attrs:{"endPoint":_vm.route,"filterEndpoint":_vm.filterEndpoint,"formType":_vm.formType,"viewOnly":_vm.viewOnly}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }